import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { GetAll } from "adminApi/GrandLoanApi/GrandLoanApi";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/GrandLoan.json";

const GrandLoanListTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields;

  // Fetch paginated data
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
    page,
    limit,
    search: debouncedSearch,
    title: "Grant Loan List",
  });

  // Auto-generate display fields from tabledata config
  const displayFields = generateDisplayFields(tabledata);

  // Build table columns and formatted rows
  const { formattedData, columns } = useTableConfig({
    data,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Grand Loan",
      editUrl: "edit-grand-loan",
      idKey: "grand_loan_id",
      displayFields,
    },
    IsDelete: false,
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default GrandLoanListTable;
